module.exports = __webpack_public_path__ + "img/background.d8f19d7d.png";